import { put, takeEvery } from 'redux-saga/effects';
import { getProductScope } from '@discover-frontend/utils';
import {
  DELETE_NOTIFICATION_FAILURE,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  MARK_ALL_NOTIFICATIONS_AS_READ_FAILURE,
  MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
  MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
  MARK_NOTIFICATION_AS_READ_FAILURE,
  MARK_NOTIFICATION_AS_READ_REQUEST,
  MARK_NOTIFICATION_AS_READ_SUCCESS,
  OPEN_AUDIENCE_FAILURE,
  OPEN_AUDIENCE_REQUEST,
  OPEN_AUDIENCE_SUCCESS,
  RECEIVED_NOTIFICATION,
} from '../constants/action-types';
import sagaFetch from './SagaFetch';
import * as repositoryApi from '../services/repositoryApi';
import * as accountsApi from '../services/accountsApi';
import {
  addApplicationTab,
  hideModal,
  requestNotifications,
  requestRepository,
} from '../actions';

function* fetchNotifications(action) {
  const { notify_type } = action;
  const queryStringArr = [];

  queryStringArr.push(`notify_type=${notify_type}`);

  queryStringArr.push(`scope=${getProductScope()}`);

  const queryString = `?${queryStringArr.join('&')}`;
  const { response, error } = yield sagaFetch(
    accountsApi.fetchGetNotificationsApi,
    queryString
  );
  if (!error) {
    return yield put({
      type: GET_NOTIFICATIONS_SUCCESS,
      response: response.data,
    });
  }
  return yield put({ type: GET_NOTIFICATIONS_FAILURE, message: error });
}

function* handleOpenAudienceRequest(action) {
  const { id } = action;
  const { response, error } = yield sagaFetch(
    repositoryApi.fetchGetAudienceApi,
    id
  );

  if (!error) {
    yield put(hideModal());
    return yield put({
      type: OPEN_AUDIENCE_SUCCESS,
      data: response.data,
    });
  }
  return yield put({ type: OPEN_AUDIENCE_FAILURE, message: error });
}

function* handleOpenAudienceSuccess(action) {
  const { data } = action;
  const audience = {
    label: data.label,
    id: data.id,
    persistence: 'temporary',
    metadata: data,
  };
  return yield put(addApplicationTab(audience, 'analyze'));
}

function* fetchDeleteNotification(action) {
  const { notificationId } = action;
  const { response, error } = yield sagaFetch(
    accountsApi.fetchDeleteNotificationApi,
    notificationId
  );
  if (!error) {
    return yield put({
      type: DELETE_NOTIFICATION_SUCCESS,
      response,
    });
  }
  return yield put({ type: DELETE_NOTIFICATION_FAILURE, message: error });
}

function* fetchMarkNotificationAsRead(action) {
  const { notificationId } = action;
  const { response, error } = yield sagaFetch(
    accountsApi.fetchMarkNotificationAsReadApi,
    notificationId
  );
  if (!error) {
    return yield put({
      type: MARK_NOTIFICATION_AS_READ_SUCCESS,
      response,
    });
  }
  return yield put({ type: MARK_NOTIFICATION_AS_READ_FAILURE, message: error });
}

function* fetchMarkAllNotificationsAsRead() {
  const { response, error } = yield sagaFetch(
    accountsApi.fetchMarkAllNotificationsAsReadApi
  );
  if (!error) {
    return yield put({
      type: MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
      response,
    });
  }
  return yield put({
    type: MARK_ALL_NOTIFICATIONS_AS_READ_FAILURE,
    message: error,
  });
}

function* handleNotificationActionSuccess() {
  yield put(requestNotifications('SHARE_QUERY'));
  return yield put(requestNotifications('SHARE_CUSTOM_TEMPLATE'));
}

function* handleReceivedNotification() {
  yield put(requestRepository('recent'));
}

export function* shareQueryActionWatcher() {
  yield takeEvery(GET_NOTIFICATIONS_REQUEST, fetchNotifications);
  yield takeEvery(DELETE_NOTIFICATION_REQUEST, fetchDeleteNotification);
  yield takeEvery(
    MARK_NOTIFICATION_AS_READ_REQUEST,
    fetchMarkNotificationAsRead
  );
  yield takeEvery(
    MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
    fetchMarkAllNotificationsAsRead
  );
  yield takeEvery(DELETE_NOTIFICATION_SUCCESS, handleNotificationActionSuccess);
  yield takeEvery(
    MARK_NOTIFICATION_AS_READ_SUCCESS,
    handleNotificationActionSuccess
  );
  yield takeEvery(
    MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
    handleNotificationActionSuccess
  );
  yield takeEvery(OPEN_AUDIENCE_REQUEST, handleOpenAudienceRequest);
  yield takeEvery(OPEN_AUDIENCE_SUCCESS, handleOpenAudienceSuccess);
  yield takeEvery(RECEIVED_NOTIFICATION, handleReceivedNotification);
}
